import { _debounce } from "../utils";

export default function reportsAjax() {
  const section = document.querySelector("[data-reports]");

  if (!section) return;
  const resultsContainer = section.querySelector(".reports_content");
  const innerGrid = resultsContainer.querySelector(".grid");
  const loadMore = resultsContainer.querySelector(".load-more");

  const sort = document.querySelector("[data-sort]");
  const search = document.querySelector("[data-search]");

  const choices = sort.querySelectorAll(".select");
  const activeChoice = sort.querySelector(".active");
  const input = search.querySelector("input");
  const reset = search.querySelector(".reset");

  let isFetching = false;
  let order = [...choices].filter((c) => c.classList.contains("selected"))[0]
    .dataset.value;
  let maxPages = innerGrid.dataset.maxPages;
  let page = 1;
  let str = "";

  function onReset() {
    // resultsContainer.classList.remove("error");
    search.classList.remove("searched");
    page = 1;
    input.value = "";
    input.focus();
    str = input.value.trim();
    ajaxFilter();
  }

  function onError() {
    resultsContainer.classList.add("error");
    innerGrid.innerHTML = "";
    loadMore.classList.add("hidden");
  }

  function onSuccess(result) {
    let posts = result.posts.join("");
    maxPages = result.max_pages;

    resultsContainer.classList.remove("error");

    if (page === 1) {
      innerGrid.innerHTML = posts;
    } else {
      innerGrid.innerHTML += posts;
    }
    toggleLoadMore();
  }

  function onSearch() {
    let empty = !str || str.length === 0;
    search.classList.toggle("searched", !empty);
    if (empty) {
      onReset();
    } else {
      ajaxFilter();
    }
  }

  const onInput = _debounce((e) => {
    page = 1;
    str = input.value.trim();
    onSearch();
  }, 300);

  function showResults(r) {
    !r.error ? onSuccess(r) : onError();
  }

  function toggleLoadMore() {
    loadMore.classList.toggle("hidden", maxPages == page);
  }

  async function ajaxFilter() {
    if (isFetching) return;
    isFetching = true;
    innerGrid.classList.add("loading");

    let response;
    let data = new FormData();

    data.append("action", "filterReports");
    data.append("str", str);
    data.append("order", order);
    data.append("page", page);

    try {
      response = await fetch(BAMBOO.ajaxUrl, {
        method: "POST",
        credentials: "same-origin",
        body: data,
      });
    } catch (error) {
      console.log(error);
    } finally {
      isFetching = false;
      loadMore && (loadMore.disabled = false);
    }

    // Get response
    if (response.ok) {
      let result = await response.json();
      showResults(result);
    } else {
      console.log(response.status);
    }

    innerGrid.classList.remove("loading");
  }

  input.addEventListener("input", onInput);
  activeChoice.addEventListener("click", () => sort.classList.toggle("opened"));
  reset.addEventListener("click", onReset);

  choices.forEach((choice, i) => {
    choice.addEventListener("click", (e) => {
      choices.forEach((c, x) => c.classList.toggle("selected", i == x));
      activeChoice.innerHTML = choice.textContent;
      activeChoice.click();
      order = choice.dataset.value;
      page = 1;
      ajaxFilter();
    });
  });

  // Load more
  loadMore &&
    loadMore.addEventListener("click", () => {
      page++;
      loadMore.disabled = true;
      ajaxFilter();
    });

  loadMore && toggleLoadMore();
}
